import { useState } from 'react';

export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, type = 'info', duration = 5000) => {
    const id = Date.now() + Math.random();
    const newToast = {
      id,
      message,
      type,
      duration,
      isVisible: true,
    };

    setToasts(prev => [...prev, newToast]);

    // Auto-remove after duration
    if (duration > 0) {
      setTimeout(() => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
      }, duration + 300); // Add 300ms for exit animation
    }

    return id;
  };

  const hideToast = (id) => {
    setToasts(prev => 
      prev.map(toast => 
        toast.id === id ? { ...toast, isVisible: false } : toast
      )
    );

    // Remove from array after animation
    setTimeout(() => {
      setToasts(prev => prev.filter(toast => toast.id !== id));
    }, 300);
  };

  const showSuccess = (message, duration) => 
    showToast(message, 'success', duration);
  
  const showError = (message, duration) => 
    showToast(message, 'error', duration);
  
  const showWarning = (message, duration) => 
    showToast(message, 'warning', duration);
  
  const showInfo = (message, duration) => 
    showToast(message, 'info', duration);

  const clearAllToasts = () => {
    setToasts([]);
  };

  return {
    toasts,
    showToast,
    hideToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    clearAllToasts,
  };
}; 